import { resolveThemePreference } from "mazey";
import { applyTheme, THEME_STORAGE_KEY } from "./theme";
const result = resolveThemePreference(THEME_STORAGE_KEY);
applyTheme(result.value);
